<div class="global-loader" *ngIf="loading$ | async">
  <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
</div>
<router-outlet></router-outlet>
